enum LogoType {
  blue = 'blue',
  pink = 'pink',
  none = 'none',
}

export default LogoType;
